import { Table, Updater } from '@tanstack/react-table';
import { PaginatorProps } from '../render/default/paginator';
import { TableV2LogicProps } from '../types';

export function getControlledPaginationProps(pagination: NonNullable<TableV2LogicProps['pagination']>): PaginatorProps {
  const { paginationState, setPaginationState, pageCount } = pagination;
  return {
    enablePagination: pagination.enablePagination !== undefined ? pagination.enablePagination : true,
    gotoPage: (updater: Updater<number>) => {
      const pageIndex = typeof updater === 'function' ? updater(paginationState.pageIndex) : updater;
      setPaginationState(curr => ({ ...curr, pageIndex }));
    },
    nextPage: () => {
      setPaginationState({ ...paginationState, pageIndex: paginationState.pageIndex + 1 });
    },
    previousPage: () => {
      setPaginationState({ ...paginationState, pageIndex: paginationState.pageIndex - 1 });
    },
    canNextPage: paginationState.pageIndex < pageCount - 1,
    canPreviousPage: paginationState.pageIndex > 0,
    pageCount: pagination.pageCount,
    pageIndex: paginationState.pageIndex,
    pageSize: paginationState.pageSize,
    setPageSize: (updater: Updater<number>) => {
      const pageSize = typeof updater === 'function' ? updater(paginationState.pageSize) : updater;
      setPaginationState(oldState => ({ ...oldState, pageSize }));
    },
  };
}

export function getUncontrolledPaginationProps<T extends object>(table: Table<T>): PaginatorProps {
  return {
    enablePagination: table.getState().pagination.pageSize > 0,
    gotoPage: table.setPageIndex,
    nextPage: table.nextPage,
    previousPage: table.previousPage,
    canNextPage: table.getCanNextPage(),
    canPreviousPage: table.getCanPreviousPage(),
    pageCount: table.getPageCount(),
    pageIndex: table.getState().pagination.pageIndex,
    pageSize: table.getState().pagination.pageSize,
    setPageSize: table.setPageSize,
  };
}

const DEFAULT_PAGE_SIZE = 10;

export function getPageSizeStateFromProp(pageSizeOption: number | false | 'default' = 'default'): number {
  if (pageSizeOption === 'default') {
    return DEFAULT_PAGE_SIZE;
  }
  if (pageSizeOption === false) {
    return -1;
  }
  return pageSizeOption;
}
